<div id="users-list">
  <iframe [src]="iframeUrl"></iframe>
</div>
